export const devApiUrl = "https://api-homologacao.thalamus.ind.br/api/";
export const prodApiUrl = "https://api.thalamus.ind.br/api/";
